import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { AllConsumers } from "ui/organizms/Consumers";

const Consumers = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Consumers | All'
    >
        <AllConsumers />
    </Screen>
);

export default memo(Consumers);
